import axios from 'axios';

import routes from 'app/routes';

export default {
  load: (dispatch) => {
    axios
      .get(routes.api.members.index, { params: { need_invite: 1 } })
      .then((resp) => {
        dispatch({ type: 'LOAD', members: resp.data.data });
      });
  },
};
